import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const saveBuyers = async (
  appointmentId: string,
  buyers: string[],
): Promise<{ buyers?: string[] }> => {
  const config: AxiosRequestConfig = {
    url: `/appointments/${appointmentId}/save_buyers`,
    method: 'post',
    data: {
      buyers,
    },
  };

  const { data } = await axios.request<{ buyers: string[] }>(config);
  return data || {};
};

export default saveBuyers;
